import { formatString } from "./generic.util";

export function getInitials(fullName?: string): string {
  if (!fullName) {
    return "";
  }
  const nameParts = fullName.trim().split(" ");
  if (nameParts.length > 1) {
    return (
      formatString(nameParts[0][0], "uppercase") +
      formatString(nameParts[nameParts.length - 1][0], "uppercase")
    );
  }
  return formatString(nameParts[0][0] + nameParts[0][1], "uppercase");
}
